import { render } from "./asset-allocation.vue?vue&type=template&id=6248b64a&scoped=true"
import script from "./asset-allocation.vue?vue&type=script&lang=js"
export * from "./asset-allocation.vue?vue&type=script&lang=js"

import "./asset-allocation.vue?vue&type=style&index=0&id=6248b64a&scoped=true&lang=less"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6248b64a"]])

export default __exports__